import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'
import { addToast } from 'containers/Toasts/actions'

import {
  getAnnouncementsLogoError,
  getAnnouncementsLogoSuccess,
  submitAnnouncementsLogoError,
  submitAnnouncementsLogoSuccess,
} from './actions'
import { GET_ANNOUNCEMENTS_LOGO_ASYNC, SUBMIT_ANNOUNCEMENTS_LOGO_ASYNC } from './constants'

const fetchAnnouncementsLogoEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS, GET_ANNOUNCEMENTS_LOGO_ASYNC.INITIATE)
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.endUserAlerts)
      return true
    })
    .mergeMap(() =>
      api.settings
        .getAnnouncementsLogo(
          store.getState().partnerOptions.selectedCompany?.value || store.getState().app.data.id
        )
        .map((response) => getAnnouncementsLogoSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(getAnnouncementsLogoError, error)))
        .takeUntil(action$.ofType(GET_ANNOUNCEMENTS_LOGO_ASYNC.CANCEL))
    )

const submitAnnouncementsLogoEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(SUBMIT_ANNOUNCEMENTS_LOGO_ASYNC.INITIATE).mergeMap(() =>
    api.settings
      .updateAnnouncementsLogo(store.getState().partnerOptions.selectedCompany?.value, {
        notificationsLogoTemplate:
          store.getState().settings.notifications.logo.data?.notificationsLogoTemplate,
      })
      .mergeMap((response) =>
        Observable.of(submitAnnouncementsLogoSuccess(response), addToast({ message: 'Updated!' }))
      )
      .catch((error) => Observable.of(epicsErrorHandler(submitAnnouncementsLogoError, error)))
      .takeUntil(action$.ofType(SUBMIT_ANNOUNCEMENTS_LOGO_ASYNC.CANCEL))
  )

export default combineEpics(fetchAnnouncementsLogoEpic, submitAnnouncementsLogoEpic)
